import React from 'react';
import WeatherData from '../../../core/WeatherData';
import { ResponsiveContainer, BarChart, Bar, YAxis, XAxis, Tooltip } from 'recharts';

interface RainChart {
    weatherData: WeatherData
}

export default class RainChartComponent extends React.Component<RainChart> {
    constructor(props: RainChart) {
        super(props);

        this.state = {
            showCurrent: true,
            riverChart: true,
            rainChart: false,
            temperatureChart: false
        };
    }

    render() {
  
        const volumes = this.props.weatherData.getRainVolumes();
        const chartData = volumes.map((l, i) => { return { x: `${l.getPeriod()}h`, chuva: Math.round(l.getVolume()) }; });
        return (
            <ResponsiveContainer width="100%" height={152}>
                <BarChart data={chartData} margin={{top: 5, bottom: 5}}>
                    <XAxis dataKey="x" tick={{fontSize: 12 }} angle={-30} textAnchor='end' />
                    <YAxis tick={{fontSize: 12 }} interval={'preserveStartEnd'}/>
                    <Tooltip formatter={(value: number) => [`${value} mm`, 'Chuva']} cursor={{ fill: 'transparent' }} />
                    <Bar dataKey="chuva" fill="darkBlue" />
                </BarChart>
            </ResponsiveContainer>
        )
    }
}
